import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { FirstRun } from './pages/FirstRun';
import {
  UserProfileProvider,
  useUserProfile,
} from './hooks/useUserProfile';
import { resolveProfileGate } from './lib/profileExperience';
import { appRoutes } from './routes';
import { Install } from './pages/Install';
import { PUBLIC_INSTALL_PATH } from './lib/publicInstall';

const router = createBrowserRouter(appRoutes);

export function App(): JSX.Element {
  return (
    <UserProfileProvider>
      <ProfileGate />
    </UserProfileProvider>
  );
}

export function ProfileGate(): JSX.Element {
  // The permanent install/onboarding page must remain reachable before a
  // profile exists; it intentionally has no application shell or nav.
  const pathname = globalThis.location?.pathname ?? '';
  if (pathname.replace(/\/$/, '') === PUBLIC_INSTALL_PATH) {
    return <Install />;
  }
  const { profile, loading, loadError, retryLoad } = useUserProfile();
  const view = resolveProfileGate({ profile, loading, loadError });
  if (view === 'loading') {
    return <div className="profile-gate-status">Loading your local profile…</div>;
  }
  if (view === 'error') {
    return (
      <main className="first-run">
        <section className="first-run__card" role="alert">
          <h1>Profile unavailable</h1>
          <p>{loadError}</p>
          <button type="button" className="btn btn-primary" onClick={retryLoad}>
            Try again
          </button>
        </section>
      </main>
    );
  }
  return view === 'application' ? <RouterProvider router={router} /> : <FirstRun />;
}
